import React, { useEffect, useState, useContext, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../Routes/AuthProvider";

const REACT_APP_API = process.env.REACT_APP_API_BASE_URL;
const Forgot = () => {
	const navigate = useNavigate();

	const [email, setEmail] = useState("");
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const emailRef = useRef("");

	const handleForgotPassword = async (e) => {
		e.preventDefault();
		setError("");

		const emailValue = email.trim();
		if (!emailValue) {
			setError("Please enter Email ID.");
			emailRef.current?.focus();
			return;
		}
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(emailValue)) {
			setError("Please enter a valid Email ID.");
			emailRef.current?.focus();
			return;
		}
		
		setLoading(true);
		try {
			const params = {
				email: email,
			};
			const res = await axios.post(`${REACT_APP_API}/api/Account/ForgotPassword`, params);
			alert(res.data.message);
			navigate("/flight");
		} catch (err) {
			setError("Invalid user email id");
		} finally {
			setLoading(false);
		}
	};


	return (
		<>
			<div id="kt_body" class="auth-bg">
				<div class="d-flex flex-column flex-root">
					<div class="d-flex flex-column flex-column-fluid flex-lg-row">
						<div class="d-flex flex-center w-lg-50 pt-15 pt-lg-0 px-10">
							<div class="d-flex flex-center flex-lg-start flex-column mobile-none">

								<a href="/" class="mb-7">
									<img src="/assets/images/logo.png" alt="img" className='logo_login' />
								</a>
								<h2 class="text-white fw-normal m-0">Travel Management System</h2>
							</div>
						</div>
						<div class="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12">

							<div class="bg-body d-flex flex-column align-items-stretch flex-center rounded-4 w-md-500px p-10">

								<div class="d-flex flex-center flex-column flex-column-fluid px-lg-0">

									<form class="form w-100" onSubmit={handleForgotPassword}>

										<div class="text-center mb-10">
											<img src="/assets/images/logo.png" alt="img" className='logo_login mb-10 desk-none' />
											<h1 class="text-gray-900 fw-bolder mb-3">Forgot Password ?</h1>

											<div class="text-gray-500 fw-semibold fs-6">Enter your email to reset your password.</div>

										</div>
										<div class="fv-row mb-8">
											<input
												ref={emailRef}
												type="text"
												placeholder="Email"
												className="form-control bg-transparent"
												value={email}
												onChange={(e) => { setEmail(e.target.value); setError(""); }}
											/>
											{error && <p className="text-danger">{error}</p>}
										</div>
										<div class="d-grid mb-10">
											<button
												type="submit"
												id="kt_password_reset_submit"
												className="btn btn-primary"
												disabled={loading}
											>
												{loading ? (
													<>
														<span className="spinner-border spinner-border-sm me-2"></span>
														Please wait...
													</>
												) : (
													<span className="indicator-label">Submit</span>
												)}
											</button>
										</div>
										<div class="text-gray-500 text-center fw-semibold fs-6">Already have an account?
                                            <a href="/login" class="link-primary">Sign in</a></div>
									</form>
								</div>

							</div>
						</div>

					</div>
				</div>
			</div>


		</>
	);
}

export default Forgot;
